import { DetectedEvent } from '@ais-ui/websockets';
import { useLocalization } from '@ais-ui/locale-management';
import React from 'react';

import { EventGridItem } from './EventGridItem';

interface ShipEventItemProps {
  event: DetectedEvent;
}

export const ShipEventItem = ({ event }: ShipEventItemProps) => {
  const { messages } = useLocalization();

  return (
    <div className="grid grid-cols-2 gap-4">
      <EventGridItem
        label={messages.eventsItemShipNameLabel}
        value={event.shipName}
      />
      <EventGridItem
        label={messages.eventsItemMmsiLabel}
        value={event.mmsi.toString()}
      />
      <EventGridItem label={messages.eventsItemImoLabel} value={event.imo} />
      <EventGridItem
        label={messages.eventsItemCallsignLabel}
        value={event.callSign}
      />
    </div>
  );
};
